import './App.css';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Booking from './components/Booking';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import AdminPage from './components/AdminPage';
import Gallery from './pages/Gallery';

function App() {
  const navigate = useNavigate();

  return (
    <Routes>
      {/* Home Page */}
      <Route
        path="/"
        element={
          <div className="bg-Pink-base flex flex-col justify-start items-start w-full">
            <Header onNavigateGallery={() => navigate('/gallery')} />
            <Hero />
            <Booking />
            <Footer onShowAdmin={() => navigate('/admin')} />
            <BackToTop />
          </div>
        }
      />

      {/* Gallery Page */}
      <Route path="/gallery" element={<Gallery />} />

      {/* Admin Page */}
      <Route path="/admin" element={<AdminPage onLogout={() => navigate('/')} />} />
    </Routes>
  );
}

export default App;
